var map = {
	"./g1.jpg": 1075,
	"./g2.jpg": 7842,
	"./g3.jpg": 8999,
	"./g4.jpg": 2015,
	"./g5.jpg": 7397,
	"./g6.jpg": 24,
	"./g7.jpg": 3088,
	"./g8.jpg": 9402,
	"./g9.jpg": 3459
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4759;